import React from 'react';
import { styled, useStyletron } from 'baseui';
import { ParagraphSmall, ParagraphXSmall } from 'baseui/typography';
type Props = {
  header: string;
  content: string;
  isExpanded?: boolean;
};
const Container = styled<'div', {
  $expanded: boolean;
}>('div', ({
  $theme,
  $expanded
}) => ({
  display: 'flex',
  gap: $expanded ? $theme.sizing.scale300 : $theme.sizing.scale100,
  flexDirection: $expanded ? 'column' : 'row',
  flexWrap: 'wrap',
  padding: $expanded ? 0 : `${$theme.sizing.scale100} 0`
}));
const PrimaryParagraph = ({
  children,
  $expanded
}: {
  children: React.ReactNode;
  $expanded: boolean;
}) => {
  const [, theme] = useStyletron();
  return $expanded ? <ParagraphXSmall $style={{
    margin: 0,
    padding: theme.sizing.scale300,
    backgroundColor: theme.colors.backgroundSecondary,
    borderRadius: theme.borders.radius200
  }}>
      {children}
    </ParagraphXSmall> : <ParagraphSmall margin={0} $style={{
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }}>
      {children}
    </ParagraphSmall>;
};
const SecondaryParagraph = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [, theme] = useStyletron();
  return <ParagraphSmall color={theme.colors.contentTertiary} margin={0}>
      {children}
    </ParagraphSmall>;
};
export const AttributeItem = ({
  header,
  content,
  isExpanded
}: Props) => {
  return <Container $expanded={isExpanded ?? false}>
      <SecondaryParagraph>{`${header}` + (isExpanded ? '' : ' : ')}</SecondaryParagraph>
      <PrimaryParagraph $expanded={isExpanded ?? false}>{content ? content : '-'}</PrimaryParagraph>
    </Container>;
};